const ExoStar = ({ size }: { size: number }) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.0003 3.99976L20.9993 8.00076L18.0823 4.04676H9.0823L15.0003 12.9998L8 20.9998L19.0003 12.9998L15.0003 20.9998L18.0003 17.9998L20.9993 22.9998H29.9993L23.5453 12.9308L30.9993 3.99976H24.0003Z"
      fill="#626262"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M0 28H10.5L15.5 17L0 28Z" fill="#FF1100" />
  </svg>
);

export default ExoStar;
